/**
 * Controls whether or not we use server components to render the cart page
 * Product Area: WEB_RETAILER_SERVER
 */
export const NEXTJS_RSC_CART_PAGE_240917 = 'NEXTJS_RSC_CART_PAGE_240917';
